import ApplicationEntry from './ApplicationEntry'

export default ApplicationEntry
